<template>
  <template v-if="inclFB">FaenasCliente: beg template<br></template>
  <div>
    <template v-if="inclFB">FaenasCliente: Modals beg<br></template>
    <ModalInformes :showModalInformes="showModalInformes" @close="closeModalInformes"
      @handleVisibilidadInformes="handleVisibilidadInformes"></ModalInformes>
    <ModalVisibilidad :showModalVisibilidad="showModalVisibilidad" @close="closeModalVisibilidad"
      @handleVisibilidad="handleVisibilidad"></ModalVisibilidad>
    <MenuAyudaResumen :showModalAyuda="showModalAyuda" @close="closeModalAyuda"></MenuAyudaResumen>
    <ModalMapaFaenas :showModalMapa="showModalMapa" :propIdFaena="this.idFaenaSeleccionada" :seriesFaenas="seriesFaenas"
      @close="closeModal">
    </ModalMapaFaenas>
    <template v-if="inclFB">FaenasCliente: Modals end<br></template>

    <div class="grid xs:grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-0">
      <div class="m-0 pt-2 rounded col-span-2">
        <!--- menu nuevo-->
        <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-1 pb-5">
          <div class="container mx-auto pt-1 pb-0 pl-0 pr-0">

            <div class="  pl-0">


              <div class="w-full lg:w-1/6 px-1 text-center">
                <div class="grid grid-cols-2 ">
                  <a href="#" class="flex flex-col items-center p-3 rounded-lg transition hover:bg-gray-50"
                    @click="loadModalVisibilidad(true)">
                    <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-8 h-8">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M2.458 12C3.732 7.943 7.522 5 12 5c4.478 0 8.268 2.943 9.542 7-.034.096-.07.192-.106.287C20.268 16.057 16.478 19 12 19c-4.478 0-8.268-2.943-9.542-7-.036-.095-.072-.191-.106-.287z" />
                      </svg>
                    </div>
                    <p class="mt-2 text-xs text-gray-900">{{ $t('visibilidad') }}</p>
                  </a>

                  <a href="#" class="flex flex-col items-center p-3 rounded-lg transition hover:bg-gray-50"
                    @click="loadModalAyuda(true)">
                    <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-8 h-8">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                      </svg>
                    </div>
                    <p class="mt-2 text-xs text-gray-900">{{ $t('informacion') }}</p>
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!--- menu nuevo-->
        <div class="container">
          <div class="w-full text-left ml-4 bg-white ">

            <span class="text-1xl   font-bold text-black ">
              {{ $t('resumen') }}
            </span>

          </div>

        </div>
        <div @dragover="handleDragOVer" @dragenter="handleDragEnter" @drop="handleDrop"
          class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 file: bg-gray-200 ml-6">
          <div class="grid grid-cols-1 min-h-full gap-2 ">
            <div v-if="this.$store.getters.getDroppables.length == 0" class="h-64 pt-10">
              <div class="flex items-start mb-4 pb-4">
                <div class="">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-12 h-12">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25" />
                  </svg>
                </div>
                <div class="">{{ $t('arrastre') }}</div>
              </div>
            </div>

            <div class="overflow-x-scroll flex items-start mb-4 pb-4 bg-white">
              <template v-if="inclFB">FaenasCliente: beg paneles<br></template>
              <div v-for="f in this.$store.getters.getDroppables" :key="f.id"
                class="bg-white w-100 o shadow rounded-br mb-0 mt-3">
                <div v-if="f.visible == 1" class="ml-auto w-357 mx-2 bg-white" style="width: 357px">
                  <PanelFaena :draggable="true" @drop="handleDropFaena(f.id)" @dragstart="handleDragFaena(f.id)" :class="{
                    'border-dotted  border-gray-600 border-2': isDragStart,
                    'border-solid border-gray-300 border-2': !isDragStart,
                    'border-solid border-red-300 border-2':
                      f.id == this.$store.getters.getIdCurrentDroppable,
                  }" @dragover="handleDragOver" :f="f" :seriesFaenas="seriesFaenas"
                    @chgHistorialCentros="loadHistorial" @chgFaenaCentros="loadCentros"
                    @sendDivisionesMenuLat="enviaDivisionesMenuLat"></PanelFaena>
                </div>
              </div>
              <template v-if="inclFB">FaenasCliente: end paneles<br></template>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 pt-3 pr-3 pl-6">
      <div class="lg:flex">
        <div class="lg:w-1/2 pl-5 text-left">
          <h1 class="text-1xl font-extrabold text-left text-cyan-800">
            {{ $t('seleccione_fechas') }}
          </h1>

          <CalendarioFaenas @getFecCalendar="getFecCalendar" :fechasSeleccionadas="fechasSeleccionadas">
          </CalendarioFaenas>
        </div>

        <div class="lg:w-1/2 text-left pr-2">

          <div v-if="mostrarSpinner == true">
            <SpinnerLoading></SpinnerLoading>
          </div>

          <span class=" text-xs" style="color:#F9FAFB">
            noShowSetpoint:'{{ noShowSetpoint }}' this.vista:'{{ this.vista }}' granularidad:'{{ granularity }}' dias:
            '{{ dias }}' this.frecuencia_minutos:'{{ this.frecuencia_minutos }}'
          </span>
        </div>
      </div>
    </div>

    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 p-3">
      <textarea id="adjustable-textarea" row="100" class="w-full  p-2 border border-gray-300 rounded
         text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 text-blue  hidden " v-model="this.fs"></textarea>

      <template v-if="inclFB">FaenasCliente: ante GraficoMultiplesFaenasDiaO2NaturalOxigenado<br></template>
      <GraficoMultiplesFaenasDiaO2NaturalOxigenado :isPortrait="isPortrait"
        :seriesMedicionesOxigenado="seriesO2Oxigenado" :seriesMedicionesNatural="seriesO2Natural"
        :glosaDataTypeOxigenado="glosaSimuladaOxigenado" :glosaDataTypeNatural="glosaDataTypeNatural"
        @loadMapa="loadMapa">
      </GraficoMultiplesFaenasDiaO2NaturalOxigenado>
      <template v-if="inclFB">FaenasCliente: desp GraficoMultiplesFaenasDiaO2NaturalOxigenado<br></template>

      <textarea id="adjustable-textarea" class="w-full  p-2 border border-gray-300 rounded   text-xs
                focus:outline-none focus:ring-2 focus:ring-blue-500 text hidden" v-model="this.fs2"></textarea>
    </div>
    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 p-3">
      <div v-if="mostrarSpinner == true">
        <SpinnerLoading></SpinnerLoading>
      </div>
      <!--  <GraficoMultiplesFaenasDiaOrp 
      @loadMapa="loadMapa" :seriesMediciones="seriesOrp" 
        nombreMedicion="ORP"
        tituloY="Ozonizado mV">
      </GraficoMultiplesFaenasDiaOrp> -->

      <template v-if="inclFB">FaenasCliente: ante GraficoMultiplesFaenasDiaOrpNaturalOzonizado<br></template>
      <GraficoMultiplesFaenasDiaOrpNaturalOzonizado :isPortrait="isPortrait"
        :seriesMedicionesOrpOzonizado="seriesOrpOzonizado" :seriesMedicionesOrpNatural="seriesOrpNatural"
        :glosaDataTypeOxigenado="glosaSimuladaOxigenado" :glosaDataTypeNatural="glosaDataTypeNatural"
        @loadMapa="loadMapa" />
      <template v-if="inclFB">FaenasCliente: desp GraficoMultiplesFaenasDiaOrpNaturalOzonizado<br></template>

    </div>

  </div>
  <template v-if="inclFB">FaenasCliente: end template<br></template>
</template>
<script>
import i18n from "@/i18n";

import CalendarioFaenas from "../calendar/CalendarioFaenas";

//import GraficoMultiplesFaenasDiaO2 from "./GraficoMultiplesFaenasDiaO2";
import GraficoMultiplesFaenasDiaO2NaturalOxigenado from "./GraficoMultiplesFaenasDiaO2NaturalOxigenado";
import GraficoMultiplesFaenasDiaOrpNaturalOzonizado from "./GraficoMultiplesFaenasDiaOrpNaturalOzonizado";
import ModalMapaFaenas from "./modal/ModalMapaFaenas";
import MenuAyudaResumen from "./modal/MenuAyudaResumen";
import ModalVisibilidad from "./modal/ModalVisibilidad";
import ModalInformes from "./modal/ModalInformes";
import PanelFaena from "./PanelFaena";
import { DateTime } from "luxon";

import axios from "axios";
import SpinnerLoading from "../SpinnerLoading";

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';


export default {
  name: "FaenasCliente",
  props: ["idEmpresa", "isSmallScreen", "isPortrait"],
  emits: [
    "chgFaena",
    "chgFaenaCentros",
    "chgDivisionesMenuLat",
    "pantallasettings",
    "handleDropFaena"
  ],
  components: {
    CalendarioFaenas,

    //  GraficoMultiplesFaenasDiaO2,
    GraficoMultiplesFaenasDiaO2NaturalOxigenado,
    GraficoMultiplesFaenasDiaOrpNaturalOzonizado,
    ModalMapaFaenas,
    MenuAyudaResumen,

    ModalVisibilidad,
    ModalInformes,
    PanelFaena,
    SpinnerLoading,


  },
  mounted() {
    this.getPreferences();
    this.datos_mensuales = [60, 20, 10, 10, 0];
    // this.loadData();
    this.loadDataSesion();
    this.enviaDivisionesMenuLat();
    this.seriesO2Loaded = true;
    this.seriesLoaded = true;


    this.fechasSeleccionadas = this.restaDias(7)

    this.soloTest = []


    //  
  },
  data() {
    return {
      glosaSimuladaOxigenado: {
        glosa: "Oxigenado: Se encontraron datos simulados",
        faenas: []

      },
      glosaDataTypeNatural: {
        glosa: "Natural: Se encontraron datos simulados",
        faenas: []

      },

      fs: '',
      result_mediciones: false,
      isDragStart: false,
      fechasSeleccionadas: [],
      mostrarSpinner: false,
      showModalMapa: false,
      showModalAyuda: false,
      showModalVisibilidad: false,
      showModalInformes: false,
      showModalUsuarios: false,
      seriesLoaded: false,

      showPanelAyuda: false,
      datos_mensuales: [],
      faenas: [{}],
      cards: [{}],
      objFaenas: [{}],
      seriesFaenas: [],
      seriesFechas: [],
      contador_instancias: 0,
      faena: "",
      jaula: "",
      fechas: "",
      soloTest: [],
      nomMes: [
        "",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],


      seriesOrp: [],
      seriesOxigeno: [],
      seriesO2Oxigenado: [],
      seriesO2Natural: [],
      idO2Disuelto: 5,
      idO2Saturado: 6,
      idOrp: 4,
      spinnerO2Disuelto: false,
      spinnerO2Saturado: false,
      idFaenaSeleccionada: 0,
      fs2: '',
      granularity: '',
      frecuencia_minutos: 0,
      inclFB: false,
      startDate: null, // Remember the latest start date in case of changes in center visibility, lg.
      endDate: null, // Remember the latest end date in case of changes in center visibility, lg.
    };
  },
  computed: {
    ...mapState('draggdrop', ['Draggables', 'Droppables'], 'auth', ['userLogin']),
    ...mapGetters('draggdrop', ['getDraggables', 'getDroppables'], 'auth', ['getUserPreferenceItems'])
  },
  methods: {

    ...mapActions("draggdropp", ["droppableAdd", "setIdCurrentDroppable", "setPosCurrentDroppable"], "divisiones", ["getDivisionesApi"]),
    ...mapMutations('draggdrop', ['draggableCreate', 'droppableCreate']),


    parseFechaChileCustom(str) {
      const dt = DateTime.fromFormat(str, 'dd HH:mm:ss MMM yyyy', {
        zone: 'America/Santiago',
        locale: 'en'
      });
      return dt.isValid ? dt.toMillis() : null;
    },

    loadModalInformes(valor) {
      //console.log("modifica estado modal");
      this.showModalInformes = valor;
    },
    loadModalVisibilidad(valor) {
      //console.log("modifica estado modal");
      this.showModalVisibilidad = valor;
    },
    loadModalAyuda(valor) {
      //console.log("modifica estado modal");
      this.showModalAyuda = valor;
    },
    closeModalAyuda() {
      this.showModalAyuda = false;
    },
    closeModalVisibilidad() {
      this.showModalVisibilidad = false;
    },
    closeModalInformes() {
      this.showModalInformes = false;
    },
    loadAyuda(resp) {
      //console.log("ayuda");
      this.showPanelAyuda = resp;
    },

    loadDataSesion() {
      this.faenas = this.$store.state.login.userLogin.info.faenas;
    },

    enviaDivisionesMenuLat() {
      this.$emit("chgDivisionesMenuLat", this.faenas);
    },
    loadMapa(id) {
      //console.log("LOAD MAPA", id);
      this.showModalMapa = true;
      this.idFaenaSeleccionada = id;
    },
    closeModal() {
      this.showModalMapa = false;
    },
    loadDivisiones(f) {
      this.$emit("chgFaena", f);
    },
    loadCentros(f) {
      this.$emit("chgFaenaCentros", f);
    },
    loadHistorial(f) {
      this.$emit("chgHistorialCentros", f);
    },
    loadHomeSettings() {
      this.$emit("chgIdPantalla", { id: 0 });
    },
    getGranularity(fecha1, fecha2) {

      const dias = this.$store.getters.diferenciaDias(fecha1, fecha2);
      if (dias <= 7) {
        return 'HOUR';
      } else {
        return 'DAY';
      }
      /*
    const vista = 'historial';
    const minutos = this.diferenciaMinutos(fecha1, fecha2);  
    const granularity = this.$store.getters.calculaPuntosGranularidad( minutos, vista)
    return granularity;

*/
    },


    async getFecCalendar(f) {
      //  //console.log('calendario', f);
      /*  este es el formato de f --> [ "01 10 2023",   "31 10 2023"]   */
      this.soloTest = []
      if (f[0] == "" || f[1] == "") return false;

      //console.log("dates paso1:", f[0], f[1])

      const startDate = this.convertirFormatoFecha(f[0]); //2023-11-01
      const endDate = this.convertirFormatoFecha(f[1]);


      ////console.log('agrega seriesFechas', this.seriesFechas);
      this.fechaConsulta = f;

      //this.arrayDias = this.seriesFechas
      this.glosaDataTypeNatural.faenas = [];
      this.glosaSimuladaOxigenado.faenas = [];


      this.spinnerO2Disuelto = true;
      this.mostrarSpinner = true;
      /*
      let natural = await this.getSeriesDia(startDate, endDate, this.idO2Disuelto, 'S');

      let oxigenado = await this.getSeriesDia(startDate, endDate, this.idO2Disuelto, 'N');
      this.seriesOxigeno = [[], natural, oxigenado]; // para botones opcion 1, opcion 2
      this.fs=JSON.stringify(oxigenado);
      let naturalOrp = await this.getSeriesDia(startDate, endDate, 4, 'S');
      let ozonizado = await this.getSeriesDia(startDate, endDate, 4, 'N');
      this.seriesOrp = [[], naturalOrp, ozonizado]; // para botones opcion 1, opcion 2
       */
      const vista = "resumen";
      this.frecuencia_minutos = this.$store.getters.diferenciaMinutos(startDate, endDate);
      //console.log('f1',this.frecuencia_minutos);
      this.granularity = this.$store.getters.calculaPuntosGranularidad(this.frecuencia_minutos, vista)


      this.seriesFechas = this.granularity == 'DAY'
        ? this.$store.getters.generaSerieFechas(startDate, endDate)
        : this.$store.getters.generaSerieHoras(startDate, endDate);


      this.startDate=startDate; // Remember the latest start date in case of changes in center visibility, lg.
      this.endDate=endDate; // Remember the latest end date in case of changes in center visibility, lg.
      this.getParametrosBuscadosEnSeriesDias_2(startDate, endDate);
    },

    async getParametrosBuscadosEnSeriesDias(startDate, endDate) {
      Promise.allSettled([
        this.getSeriesDia(startDate, endDate, this.idO2Disuelto, 'S'),
        this.getSeriesDia(startDate, endDate, this.idO2Disuelto, 'N'),
        this.getSeriesDia(startDate, endDate, this.idOrp, 'S'),
        this.getSeriesDia(startDate, endDate, this.idOrp, 'N')
      ])
        .then(results => {

          const [natural, oxigenado, naturalOrp, ozonizado] = results.map(r => r.status === 'fulfilled' ? r.value : []);


          this.seriesOxigeno = [[], natural, oxigenado]; // para botones opción 1, opción 2
          this.seriesO2Oxigenado = oxigenado;
          this.seriesO2Natural = natural;

          this.seriesOrp = [[], naturalOrp, ozonizado]; // para botones opción 1, opción 2
          this.seriesOrpOzonizado = ozonizado;
          this.seriesOrpNatural = naturalOrp;
          this.mostrarSpinner = false;
        })
        .catch(error => {
          console.error('Error en promesas getSeriesDia:', error);
        });
    },

    async getSeriesDia(startDate, endDate, parametroBuscado, es_faena_natural) {

      console.log("FaenasCliente: getSeriesDia() begin");

      let dataFaena = [];


      try {


        const apiKey = this.$store.state.login.tokenLogin;
        const objFaenas = this.$store.state.faenas;
        let arrayFaenas = [];

        console.log("FaenasCliente: getSeriesDia(): arrayFaenas=", arrayFaenas, ".");
        // arrayFaenas = objFaenas.faenas;  //  All centers, lg.
        arrayFaenas = objFaenas.faenas.filter(faena=>faena.visible==true);  //  Visible centers only, lg.
        console.log("FaenasCliente: getSeriesDia(): arrayFaenas=", arrayFaenas, ".");

        console.log('test faenas', arrayFaenas.length)
        for (let x = 0; x < arrayFaenas.length; x++) {
          // todas las jaulas de la Faena
          /*
           "unidades": [
                        {
                            "id": 1101,
                            "descripcion": "Jaula 101",
                            "tipo": "Jaula",
                            "natural": "N",
                            "setpoints": [],
                            "valvulas": [],
                            "sensores": [
                                105
                            ]
                        },
          */
          let objFaena = arrayFaenas[x];
          let jaulas = objFaena.unidades.filter(faena => faena.natural == es_faena_natural);
          const jaulaPromises = jaulas.map((jaula) => {
            if (jaula.id !== undefined) {
              const requestData = {
                idUnit: jaula.id,
                tsi: `${startDate} 00:00:00`,
                tsf: `${endDate} 23:59:59`,
                granularity: this.granularity,
              };
              return axios
                .post("/api/mon/getUnitData", requestData, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `${apiKey}`,
                  },
                })
                .then((response) => {

                  let sensors = response.data.payload.sensors;
                  let arrayLecturas = []
                  sensors.forEach(sensor => {
                    sensor.params.forEach(param => {



                      if (param.id == parametroBuscado) {

                        if ("injectionType" in param && param.injectionType == 'dummy') {
                          if (es_faena_natural == 'S' && !this.glosaDataTypeNatural.faenas.includes(objFaena.nombre)) {
                            this.glosaDataTypeNatural.faenas.push(objFaena.nombre);
                          } else {
                            if (!this.glosaSimuladaOxigenado.faenas.includes(objFaena.nombre))
                              this.glosaSimuladaOxigenado.faenas.push(objFaena.nombre);
                          }
                        }

                        let updatedData = param.values;
                        updatedData.forEach(valor => {

                          let obj = {}
                          if (valor.value) {
                            // valor medicion y fecha medicion
                            obj = {
                              'jaulaId': jaula.id,
                              'value': valor.value,
                              'ts': valor.ts,
                              'injection': valor.injection
                            }

                            arrayLecturas.push({ ...obj });

                          }

                        });
                      }

                    });
                  });

                  return arrayLecturas

                })
                .catch((error) => {
                  console.log("error fetching unit data", error);
                  return [];
                });
            }

          });

          const arrayUnidades = await Promise.all(jaulaPromises);
          let dataFaenaDiario = [];
          /*
          1) recorrer arrayUnidades 
              [{
              jaulaId, value, ts
              },
              {
              jaulaId, value, ts
              },
              {
              jaulaId, value, ts
              }]
          2)  agregar a dataFaenaDiario[] objeto :
              { 
                'ts': (aaaa-mm-dd),  // campo de busqueda
                'acumulado': (valor medicion del dia + lo acumulado), 
                'jaulas_con_mediciones_ese_dia':  (cantidad incremental )
              }
          */
          arrayUnidades.forEach((mediciones) => {
            mediciones.forEach((medicion) => {

              let n = Math.floor(medicion.value * 100) / 100; // truncar sin rendondear
              const fec = medicion.ts;
              // const uni = medicion.jaulaId;
              const injection = medicion.injection;
              let dateSplit = ''


              if (this.granularity == 'DAY') {
                dateSplit = fec.split(" ")[0];

              } else {
                //console.log('granularidad hora', fec);
                dateSplit = fec;
              }


              dateSplit = fec;

              if (dateSplit) {



                let index = dataFaenaDiario.findIndex(function (obj) {

                  return obj.ts == dateSplit;
                });



                if (index !== -1) {

                  ////console.log('chk uni:', uni);
                  ////console.log('chk (existe fecha ', dateSplit, ' en [])')

                  let cantidad_unidades = dataFaenaDiario[index].jaulas_con_mediciones_ese_dia;
                  cantidad_unidades++;

                  let acumulado = parseFloat(dataFaenaDiario[index].acumulado);
                  let totdia = parseFloat(n)

                  if (injection) {
                    dataFaenaDiario[index].injection = injection;
                  } else {
                    if (dataFaenaDiario[index].injection == '') {
                      dataFaenaDiario[index].injection = injection;
                    }
                  }


                  ////console.log(uni, ': chk (valores acumulado en fecha', dateSplit, ':', acumulado)
                  ////console.log(uni, ': chk (agrega en fecha', dateSplit, '):', totdia)


                  dataFaenaDiario[index].acumulado = acumulado + totdia;
                  dataFaenaDiario[index].jaulas_con_mediciones_ese_dia = cantidad_unidades;


                } else {


                  dataFaenaDiario.push({
                    'ts': dateSplit,
                    'acumulado': n,
                    'injection': injection,
                    'value': 0,
                    'jaulas_con_mediciones_ese_dia': 1
                  })

                }


              }

            });


          });

          /**
          dataFaenaDiario= [
            {
                "ts":"2025-08-28 00:00:00",
                "acumulado":182.17,
                "injection":false,
                "value":0,
                "jaulas_con_mediciones_ese_dia":1
            },
            {
                "ts":"2025-08-28 01:00:00",
                "acumulado":200.06,
                "injection":false,
                "value":0,
                "jaulas_con_mediciones_ese_dia":1
            },

            if(dataFaenaDiario.length>0)
            this.fs2=JSON.stringify(dataFaenaDiario)
           */


          // calcular aqui el promedio
          // recorrer array de objetos y promediar   
          dataFaenaDiario.forEach(function (datodiario) {
            let promedio = datodiario.acumulado / datodiario.jaulas_con_mediciones_ese_dia;

            datodiario.value = Math.floor(promedio * 100) / 100; // truncar sin rendondear

          });
          this.soloTest = dataFaenaDiario;
          let datosdiarios = [];

          if (arrayUnidades) {

            // generar una serie con todas las fechas seleccionadas en el calendario, 
            // e insertar las mediciones de las fechas que  Sí registren datos en dataFaenaDiario

            // seriesFechas creado a partir del metodo  generaSerieFechas o generaSerieHoras
            for (let i = 0; i < this.seriesFechas.length; i++) {

              //console.log('seriesFechas', this.seriesFechas[i])
              let result = dataFaenaDiario.find(item => item.ts === this.seriesFechas[i]);
              if (result) {

                let ts = this.convertirFormatoFechaDMA(result.ts);
                let med = result.value ? result.value : 0;

                let fec = Date.parse(this.parseCustomDate(ts))

                datosdiarios.push([fec, parseFloat(med), result.injection]);

              } else {

                let ts = this.convertirFormatoFechaDMA(this.seriesFechas[i]);
                let fec = Date.parse(this.parseCustomDate(ts))

                datosdiarios.push([fec, 0, false]);
                this.mostrarSpinner = true;

              }


            }


          }
          let tipo = '';
          switch (parametroBuscado) {
            case this.idO2Disuelto:
              tipo = es_faena_natural == 'S' ? ` ${i18n.global.t('natural')}` : ` ${i18n.global.t('oxigenado')}`;
              break;
            case this.idOrp:
              tipo = es_faena_natural == 'S' ? ` ${i18n.global.t('natural')}` : ` ${i18n.global.t('ozonizado')}`;
              break;
          }

          let m = { name: objFaena.nombre + tipo, data: datosdiarios };

          dataFaena.push(m);
        } // itera faenas


        this.result_mediciones = true;


        return dataFaena;


      } catch (error) {
        console.log("error procesando faenas", error);
      }
    },

    async getParametrosBuscadosEnSeriesDias_2(startDate, endDate) {
      try {
        const parametroBuscados = [
          { id: this.idO2Disuelto }, // 5
          { id: this.idOrp },//4

        ];


        const [natural, oxigenado, naturalOrp, ozonizado] = await this.getSeriesDia_2(startDate, endDate, parametroBuscados)
       

        this.seriesOxigeno = [[], natural, oxigenado]; // para botones opción 1, opción 2
        this.seriesO2Oxigenado = oxigenado;
        this.seriesO2Natural = natural;

        this.seriesOrp = [[], naturalOrp, ozonizado]; // para botones opción 1, opción 2
        this.seriesOrpOzonizado = ozonizado;
        this.seriesOrpNatural = naturalOrp;
        this.mostrarSpinner = false;
      } catch (error) {
        console.error('Error en promesa getSeriesDia_2:', error);
      }
    },

    async getSeriesDia_2(startDate, endDate, parametroBuscados) {

      console.log("FaenasCliente: getSeriesDia_2() begin");

      const o2_natural = []
      const o2_no_natural = []
      const orp_natural = []
      const orp_no_natural = []
      //                                  o2 --nonat,nat--     orp- nonat, nat     


      try {


        const apiKey = this.$store.state.login.tokenLogin;
        const objFaenas = this.$store.state.faenas;
        let arrayFaenas = [];

        console.log("FaenasCliente: getSeriesDia_2(): arrayFaenas=", arrayFaenas, ".");
        // arrayFaenas = objFaenas.faenas;  //  All centers, lg.
        arrayFaenas = objFaenas.faenas.filter(faena=>faena.visible==true);  //  Visible centers only, lg.
        console.log("FaenasCliente: getSeriesDia_2(): arrayFaenas=", arrayFaenas, ".");
    
        for (const objFaena of arrayFaenas) {
          // todas las jaulas de la Faena
          /*
           "unidades": [
                        {
                            "id": 1101,
                            "descripcion": "Jaula 101",
                            "tipo": "Jaula",
                            "natural": "N",
                            "setpoints": [],
                            "valvulas": [],
                            "sensores": [
                                105
                            ]
                        },
          */
          /*
           "sensors": [
             {
                 "id": 105,
                 "params": [
                     {
                         "id": 1,
                         "values": [
                             {
                                 "value": 9.4,
                                 "ts": "2025-08-28 00:00:00",
                                 "injection": false
                             },
                            
         */

          let jaulas = objFaena.unidades;
          let jaulas_no_naturales = objFaena.unidades.filter(faena => faena.natural == 'N');

           let dataFaenaActual = [
                [[], []],  // Para O2: [no_natural, natural]  <<-- It seems to be [natural, no_natural], lg.
                [[], []]   // Para ORP: [no_natural, natural]  <<-- It seems to be [natural, no_natural], lg.
            ];
          const jaulaPromises = jaulas.map((jaula) => {

            if (jaula.id !== undefined) 
            {
              console.log("jaula", jaula.id); 
              const requestData = {
                idUnit: jaula.id,
                tsi: `${startDate} 00:00:00`,
                tsf: `${endDate} 23:59:59`,
                granularity: this.granularity,
              };
              return axios
                .post("/api/mon/getUnitData", requestData, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `${apiKey}`,
                  },
                })
                .then((response) => {

                  let jaula_no_natural = jaulas_no_naturales.find(u => u.id == jaula.id) ? true : false;
                  console.log("FaenasCliente: getSeriesDia_2: jaula.id=", jaula.id, ", jaula_no_natural=", jaula_no_natural, ".");
                  
                  let sensors = response.data.payload.sensors;
                  let lecturasJaula = [
                            [[], []],  // O2: [no_natural, natural]  <<-- It seems to be [natural, no_natural], lg.
                            [[], []]   // ORP: [no_natural, natural]  <<-- It seems to be [natural, no_natural], lg.
                        ];
                  sensors.forEach(sensor => {
                    const paramsFiltrados = sensor.params.filter(param =>
                      parametroBuscados.some(buscado => buscado.id === param.id)
                    );
                   
                    paramsFiltrados.forEach(param => {
                      let indice = parametroBuscados.findIndex(obj => obj.id === param.id)
                      if (indice !== -1) {
 
                        if ("injectionType" in param && param.injectionType == 'dummy') {
                          if (!jaula_no_natural && !this.glosaDataTypeNatural.faenas.includes(objFaena.nombre)) {
                            this.glosaDataTypeNatural.faenas.push(objFaena.nombre);
                          } else {
                            if (!this.glosaSimuladaOxigenado.faenas.includes(objFaena.nombre))
                              this.glosaSimuladaOxigenado.faenas.push(objFaena.nombre);
                          }
                        }

                        param.values.forEach(valor => 
                        {
                                        if (valor.value) 
                                        {
                                            let obj = {
                                                'jaulaId': jaula.id,
                                                'value': valor.value,
                                                'ts': valor.ts,
                                                'injection': valor.injection
                                            };

                                            // Determinar array destino
                                            const targetIndex = jaula_no_natural ? 1 : 0;  // <<-- i.e., [natural, no_natural], lg.
                                            lecturasJaula[indice][targetIndex].push(obj);
                                        }
                        });

                        /* 1109
                         {
                        "id": 4,
                        "values": [
                            {
                                "value": 182.17,
                                "ts": "2025-08-28 00:00:00",
                                "injection": false
                            },
                            {
                                "value": 200.06,
                                "ts": "2025-08-28 01:00:00",
                                "injection": false
                            },
                          {
                        "id": 5,
                        "values": [
                            {
                                "value": 7.98,
                                "ts": "2025-08-28 00:00:00",
                                "injection": false
                            },
                            {
                                "value": 7.94,
                                "ts": "2025-08-28 01:00:00",
                                "injection": false
                            },   
                        */
                        // indice corresponde a posicion del parametro buscado

                 
                    
                        
                       // console.log('indice-->',indice, jaula.id, objFaena.id)

                      }

                    });
                  });
                
               
                  console.log("FaenasCliente: getSeriesDia_2: lecturasJaula=", lecturasJaula, ".");
                  return lecturasJaula;

                })
                .catch((error) => {
                      console.log("error fetching unit data", error);
                        return [[[], []], [[], []]];
                });
            }

          });


          // dataFaena = 
          //   [ 
          //   [ [/* lecturas no natural */], [/* lecturas   natural*/], ... ],  // 0 (primer parametro buscado)
          //   [ [/*  lecturas no natural*/], [/* lecturas   natural*/], ... ],  // 1 (segundo parametro buscado)
          //  ...
          // ]


           const resultadosJaulas = await Promise.all(jaulaPromises);
            console.log('resultados',resultadosJaulas);
            // Consolidar datos de todas las jaulas de esta faena
            resultadosJaulas.forEach(lecturasJaula => {
                // O2
                dataFaenaActual[0][0].push(...lecturasJaula[0][0]); // natural
                dataFaenaActual[0][1].push(...lecturasJaula[0][1]); // no_natural
                // ORP
                dataFaenaActual[1][0].push(...lecturasJaula[1][0]); // natural
                dataFaenaActual[1][1].push(...lecturasJaula[1][1]); // no_natural
            });

            console.log("FaenasCliente: getSeriesDia_2: dataFaenaActual=", dataFaenaActual, ".");
  
          let obj = this.asociaFechasAMediciones(objFaena.nombre, dataFaenaActual[0][0],  i18n.global.t('natural')  )
          o2_no_natural.push({ ...obj });
            
          let obj2 = this.asociaFechasAMediciones(objFaena.nombre,dataFaenaActual[0][1],  i18n.global.t('oxigenado') )
          o2_natural.push({ ...obj2 });
            
          let obj3 = this.asociaFechasAMediciones(objFaena.nombre, dataFaenaActual[1][0],  i18n.global.t('natural'))
          orp_natural.push({ ...obj3 });
          
          let obj4 = this.asociaFechasAMediciones(objFaena.nombre, dataFaenaActual[1][1],   i18n.global.t('ozonizado') )
          orp_no_natural.push({ ...obj4 });

        } // itera faenas


        this.result_mediciones = true;


        // DEVOLVER 
        return [o2_natural, o2_no_natural, orp_natural, orp_no_natural];



      } catch (error) {
        console.log("error procesando faenas", error);
      }
    },


    asociaFechasAMediciones(nombreFaena, lecturas,glosa) 
    { 
      let dataFaenaDiario = this.agregarTsAcumuladoJaulasConMediciones(lecturas);
      // ❌ obj error: dataFaenaDiario vacio[]
     
      /*  deberia retornar 
           dataFaenaDiario= [
            {
                "ts":"2025-08-28 00:00:00",
                "acumulado":182.17,
                "injection":false,
                "value":0,
                "jaulas_con_mediciones_ese_dia":1
            },
            {
                "ts":"2025-08-28 01:00:00",
                "acumulado":200.06,
                "injection":false,
                "value":0,
                "jaulas_con_mediciones_ese_dia":1
            },

           
      
      */

      dataFaenaDiario.forEach(function (datodiario) {
        let promedio = datodiario.acumulado / datodiario.jaulas_con_mediciones_ese_dia;
        datodiario.value = Math.floor(promedio * 100) / 100; // truncar sin rendondear
      });
      let datosdiarios = [];
      if (lecturas) {
        // generar una serie con todas las fechas seleccionadas en el calendario, 
        // e insertar las mediciones de las fechas que  Sí registren datos en dataFaenaDiario
        // seriesFechas creado a partir del metodo  generaSerieFechas o generaSerieHoras
        for (let i = 0; i < this.seriesFechas.length; i++) {

          //console.log('seriesFechas', this.seriesFechas[i])
          let result = dataFaenaDiario.find(item => item.ts === this.seriesFechas[i]);
          if (result) {

            let ts = this.convertirFormatoFechaDMA(result.ts);
            let med = result.value ? result.value : 0;

            let fec = Date.parse(this.parseCustomDate(ts))

            datosdiarios.push([fec, parseFloat(med), result.injection]);

          } else {

            let ts = this.convertirFormatoFechaDMA(this.seriesFechas[i]);
            let fec = Date.parse(this.parseCustomDate(ts))

            datosdiarios.push([fec, 0, false]);
            this.mostrarSpinner = true;

          }


        }





      }

 

      let m = { name: nombreFaena + " " + glosa, data: datosdiarios };

      return m;



    },
/**
 * dataTodasFaenasTodasJaulas[0][0]
[
    [
        [
            [
                {
                    "jaulaId": 1101,
                    "value": 8.21,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.77,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.88,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.74,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.25,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.42,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.65,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.57,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.25,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.14,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.6,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.94,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 8.06,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.96,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.5,
                    "ts": "2025-08-28 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.74,
                    "ts": "2025-08-28 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.43,
                    "ts": "2025-08-28 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.03,
                    "ts": "2025-08-28 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.2,
                    "ts": "2025-08-28 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.35,
                    "ts": "2025-08-28 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.29,
                    "ts": "2025-08-28 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 8.78,
                    "ts": "2025-08-28 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 8.43,
                    "ts": "2025-08-28 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 8.28,
                    "ts": "2025-08-28 23:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.09,
                    "ts": "2025-08-29 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.13,
                    "ts": "2025-08-29 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.14,
                    "ts": "2025-08-29 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 8.77,
                    "ts": "2025-08-29 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 8.66,
                    "ts": "2025-08-29 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 9.07,
                    "ts": "2025-08-29 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 8.88,
                    "ts": "2025-08-29 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 8.72,
                    "ts": "2025-08-29 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.32,
                    "ts": "2025-08-29 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.15,
                    "ts": "2025-08-29 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.31,
                    "ts": "2025-08-29 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.62,
                    "ts": "2025-08-29 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.23,
                    "ts": "2025-08-29 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.15,
                    "ts": "2025-08-29 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 6.86,
                    "ts": "2025-08-29 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 6.7,
                    "ts": "2025-08-29 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 6.98,
                    "ts": "2025-08-29 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.2,
                    "ts": "2025-08-29 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.99,
                    "ts": "2025-08-29 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.92,
                    "ts": "2025-08-29 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.41,
                    "ts": "2025-08-29 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.11,
                    "ts": "2025-08-29 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 7.6,
                    "ts": "2025-08-29 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1101,
                    "value": 8.16,
                    "ts": "2025-08-29 23:00:00",
                    "injection": false
                }
            ],
            []
        ],
        [
            [],
            []
        ]
    ],
    [
        [
            [
                {
                    "jaulaId": 1102,
                    "value": 6.84,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.56,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.29,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.28,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.38,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.75,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.93,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.72,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.4,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.24,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.52,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.87,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.97,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.8,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.8,
                    "ts": "2025-08-28 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.95,
                    "ts": "2025-08-28 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.63,
                    "ts": "2025-08-28 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.43,
                    "ts": "2025-08-28 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.71,
                    "ts": "2025-08-28 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.71,
                    "ts": "2025-08-28 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.66,
                    "ts": "2025-08-28 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.37,
                    "ts": "2025-08-28 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.24,
                    "ts": "2025-08-28 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.19,
                    "ts": "2025-08-28 23:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.67,
                    "ts": "2025-08-29 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.7,
                    "ts": "2025-08-29 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.61,
                    "ts": "2025-08-29 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.48,
                    "ts": "2025-08-29 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.72,
                    "ts": "2025-08-29 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 8.03,
                    "ts": "2025-08-29 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.82,
                    "ts": "2025-08-29 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.64,
                    "ts": "2025-08-29 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.42,
                    "ts": "2025-08-29 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.33,
                    "ts": "2025-08-29 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 7.03,
                    "ts": "2025-08-29 10:00:00",
                    "injection": true
                },
                {
                    "jaulaId": 1102,
                    "value": 7.78,
                    "ts": "2025-08-29 11:00:00",
                    "injection": true
                },
                {
                    "jaulaId": 1102,
                    "value": 5.85,
                    "ts": "2025-08-29 12:00:00",
                    "injection": true
                },
                {
                    "jaulaId": 1102,
                    "value": 6.48,
                    "ts": "2025-08-29 13:00:00",
                    "injection": true
                },
                {
                    "jaulaId": 1102,
                    "value": 6.26,
                    "ts": "2025-08-29 14:00:00",
                    "injection": true
                },
                {
                    "jaulaId": 1102,
                    "value": 5.88,
                    "ts": "2025-08-29 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.02,
                    "ts": "2025-08-29 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.29,
                    "ts": "2025-08-29 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.45,
                    "ts": "2025-08-29 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.59,
                    "ts": "2025-08-29 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.22,
                    "ts": "2025-08-29 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.01,
                    "ts": "2025-08-29 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.13,
                    "ts": "2025-08-29 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1102,
                    "value": 6.38,
                    "ts": "2025-08-29 23:00:00",
                    "injection": false
                }
            ],
            []
        ],
        [
            [],
            []
        ]
    ],
    [
        [
            [
                {
                    "jaulaId": 1103,
                    "value": 6.99,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.62,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.53,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.8,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.04,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.48,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.06,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.27,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.71,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.53,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.08,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.96,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.02,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.73,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.71,
                    "ts": "2025-08-28 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.73,
                    "ts": "2025-08-28 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.7,
                    "ts": "2025-08-28 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.69,
                    "ts": "2025-08-28 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 8.13,
                    "ts": "2025-08-28 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.94,
                    "ts": "2025-08-28 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.99,
                    "ts": "2025-08-28 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.74,
                    "ts": "2025-08-28 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.77,
                    "ts": "2025-08-28 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 8.24,
                    "ts": "2025-08-28 23:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 8.19,
                    "ts": "2025-08-29 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.86,
                    "ts": "2025-08-29 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 8.1,
                    "ts": "2025-08-29 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.99,
                    "ts": "2025-08-29 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 8.26,
                    "ts": "2025-08-29 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 8.3,
                    "ts": "2025-08-29 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 8.27,
                    "ts": "2025-08-29 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 9.02,
                    "ts": "2025-08-29 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.45,
                    "ts": "2025-08-29 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.29,
                    "ts": "2025-08-29 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.77,
                    "ts": "2025-08-29 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.87,
                    "ts": "2025-08-29 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.8,
                    "ts": "2025-08-29 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.7,
                    "ts": "2025-08-29 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.56,
                    "ts": "2025-08-29 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.3,
                    "ts": "2025-08-29 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.55,
                    "ts": "2025-08-29 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.76,
                    "ts": "2025-08-29 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.09,
                    "ts": "2025-08-29 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.28,
                    "ts": "2025-08-29 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.38,
                    "ts": "2025-08-29 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 7.03,
                    "ts": "2025-08-29 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.84,
                    "ts": "2025-08-29 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1103,
                    "value": 6.98,
                    "ts": "2025-08-29 23:00:00",
                    "injection": false
                }
            ],
            []
        ],
        [
            [],
            []
        ]
    ],
    [
        [
            [
                {
                    "jaulaId": 1104,
                    "value": 7.53,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.23,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.99,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.23,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.37,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.71,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.71,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.53,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.22,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.02,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.34,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.73,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.58,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.18,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.16,
                    "ts": "2025-08-28 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.03,
                    "ts": "2025-08-28 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.21,
                    "ts": "2025-08-28 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.31,
                    "ts": "2025-08-28 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.49,
                    "ts": "2025-08-28 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.38,
                    "ts": "2025-08-28 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.36,
                    "ts": "2025-08-28 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.27,
                    "ts": "2025-08-28 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.26,
                    "ts": "2025-08-28 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.83,
                    "ts": "2025-08-28 23:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.84,
                    "ts": "2025-08-29 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.62,
                    "ts": "2025-08-29 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.4,
                    "ts": "2025-08-29 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.33,
                    "ts": "2025-08-29 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.48,
                    "ts": "2025-08-29 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.91,
                    "ts": "2025-08-29 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 9.03,
                    "ts": "2025-08-29 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 8.85,
                    "ts": "2025-08-29 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.21,
                    "ts": "2025-08-29 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.96,
                    "ts": "2025-08-29 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.91,
                    "ts": "2025-08-29 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.91,
                    "ts": "2025-08-29 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.04,
                    "ts": "2025-08-29 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.99,
                    "ts": "2025-08-29 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.96,
                    "ts": "2025-08-29 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.83,
                    "ts": "2025-08-29 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.99,
                    "ts": "2025-08-29 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.05,
                    "ts": "2025-08-29 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.04,
                    "ts": "2025-08-29 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.24,
                    "ts": "2025-08-29 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 7.1,
                    "ts": "2025-08-29 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.96,
                    "ts": "2025-08-29 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.78,
                    "ts": "2025-08-29 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1104,
                    "value": 6.8,
                    "ts": "2025-08-29 23:00:00",
                    "injection": false
                }
            ],
            []
        ],
        [
            [],
            []
        ]
    ],
    [
        [
            [
                {
                    "jaulaId": 1105,
                    "value": 7.54,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.28,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 6.88,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 6.99,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.12,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.38,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.53,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.37,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.07,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 6.77,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.2,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.22,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.56,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.23,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.02,
                    "ts": "2025-08-28 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8,
                    "ts": "2025-08-28 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.19,
                    "ts": "2025-08-28 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.07,
                    "ts": "2025-08-28 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.46,
                    "ts": "2025-08-28 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.33,
                    "ts": "2025-08-28 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.39,
                    "ts": "2025-08-28 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.21,
                    "ts": "2025-08-28 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.38,
                    "ts": "2025-08-28 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.41,
                    "ts": "2025-08-28 23:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.19,
                    "ts": "2025-08-29 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.8,
                    "ts": "2025-08-29 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.96,
                    "ts": "2025-08-29 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.02,
                    "ts": "2025-08-29 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.2,
                    "ts": "2025-08-29 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.65,
                    "ts": "2025-08-29 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.51,
                    "ts": "2025-08-29 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 8.57,
                    "ts": "2025-08-29 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 6.97,
                    "ts": "2025-08-29 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.28,
                    "ts": "2025-08-29 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 6.95,
                    "ts": "2025-08-29 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 6.96,
                    "ts": "2025-08-29 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 6.81,
                    "ts": "2025-08-29 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.22,
                    "ts": "2025-08-29 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 6.9,
                    "ts": "2025-08-29 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.27,
                    "ts": "2025-08-29 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.36,
                    "ts": "2025-08-29 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.24,
                    "ts": "2025-08-29 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.44,
                    "ts": "2025-08-29 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.76,
                    "ts": "2025-08-29 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.22,
                    "ts": "2025-08-29 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 6.9,
                    "ts": "2025-08-29 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.07,
                    "ts": "2025-08-29 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1105,
                    "value": 7.38,
                    "ts": "2025-08-29 23:00:00",
                    "injection": false
                }
            ],
            []
        ],
        [
            [],
            []
        ]
    ],
    [
        [
            [
                {
                    "jaulaId": 1106,
                    "value": 6.83,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.94,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.43,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.45,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.44,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.91,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.89,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.6,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.35,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.83,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.91,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.98,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.08,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.99,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.8,
                    "ts": "2025-08-28 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.9,
                    "ts": "2025-08-28 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 8.09,
                    "ts": "2025-08-28 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.75,
                    "ts": "2025-08-28 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 8.1,
                    "ts": "2025-08-28 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 8,
                    "ts": "2025-08-28 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.67,
                    "ts": "2025-08-28 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.44,
                    "ts": "2025-08-28 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.34,
                    "ts": "2025-08-28 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.56,
                    "ts": "2025-08-28 23:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.67,
                    "ts": "2025-08-29 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.25,
                    "ts": "2025-08-29 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 8.07,
                    "ts": "2025-08-29 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.72,
                    "ts": "2025-08-29 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.96,
                    "ts": "2025-08-29 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 8.37,
                    "ts": "2025-08-29 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 8.29,
                    "ts": "2025-08-29 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 8.27,
                    "ts": "2025-08-29 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.87,
                    "ts": "2025-08-29 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.25,
                    "ts": "2025-08-29 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.06,
                    "ts": "2025-08-29 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.36,
                    "ts": "2025-08-29 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.28,
                    "ts": "2025-08-29 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.38,
                    "ts": "2025-08-29 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.15,
                    "ts": "2025-08-29 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.19,
                    "ts": "2025-08-29 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.59,
                    "ts": "2025-08-29 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.84,
                    "ts": "2025-08-29 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 7.2,
                    "ts": "2025-08-29 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.7,
                    "ts": "2025-08-29 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.67,
                    "ts": "2025-08-29 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.63,
                    "ts": "2025-08-29 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.37,
                    "ts": "2025-08-29 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1106,
                    "value": 6.85,
                    "ts": "2025-08-29 23:00:00",
                    "injection": false
                }
            ],
            []
        ],
        [
            [],
            []
        ]
    ],
    [
        [
            [
                {
                    "jaulaId": 1107,
                    "value": 6.75,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.81,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.72,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.72,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.75,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.04,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.05,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.85,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.59,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.34,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.62,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.65,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.99,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.84,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.49,
                    "ts": "2025-08-28 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.28,
                    "ts": "2025-08-28 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.45,
                    "ts": "2025-08-28 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.6,
                    "ts": "2025-08-28 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.79,
                    "ts": "2025-08-28 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.92,
                    "ts": "2025-08-28 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.69,
                    "ts": "2025-08-28 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.69,
                    "ts": "2025-08-28 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.71,
                    "ts": "2025-08-28 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 8.16,
                    "ts": "2025-08-28 23:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.88,
                    "ts": "2025-08-29 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.86,
                    "ts": "2025-08-29 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.63,
                    "ts": "2025-08-29 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.88,
                    "ts": "2025-08-29 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 7.94,
                    "ts": "2025-08-29 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 8.2,
                    "ts": "2025-08-29 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 8.02,
                    "ts": "2025-08-29 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 8.18,
                    "ts": "2025-08-29 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.61,
                    "ts": "2025-08-29 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.33,
                    "ts": "2025-08-29 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.12,
                    "ts": "2025-08-29 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.18,
                    "ts": "2025-08-29 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.08,
                    "ts": "2025-08-29 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.22,
                    "ts": "2025-08-29 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.08,
                    "ts": "2025-08-29 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.02,
                    "ts": "2025-08-29 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.16,
                    "ts": "2025-08-29 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.42,
                    "ts": "2025-08-29 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.72,
                    "ts": "2025-08-29 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.59,
                    "ts": "2025-08-29 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.16,
                    "ts": "2025-08-29 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.29,
                    "ts": "2025-08-29 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.16,
                    "ts": "2025-08-29 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1107,
                    "value": 6.31,
                    "ts": "2025-08-29 23:00:00",
                    "injection": false
                }
            ],
            []
        ],
        [
            [],
            []
        ]
    ],
    [
        [
            [
                {
                    "jaulaId": 1108,
                    "value": 7.07,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.94,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.74,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.79,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.85,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.32,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.97,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.88,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.82,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.93,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.25,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.1,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.66,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.49,
                    "ts": "2025-08-28 14:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.33,
                    "ts": "2025-08-28 15:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.69,
                    "ts": "2025-08-28 16:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.86,
                    "ts": "2025-08-28 17:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 8.02,
                    "ts": "2025-08-28 18:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 8.08,
                    "ts": "2025-08-28 19:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 8.03,
                    "ts": "2025-08-28 20:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 8.86,
                    "ts": "2025-08-28 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 8.82,
                    "ts": "2025-08-28 22:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 8.92,
                    "ts": "2025-08-28 23:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 8.21,
                    "ts": "2025-08-29 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.92,
                    "ts": "2025-08-29 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.76,
                    "ts": "2025-08-29 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.62,
                    "ts": "2025-08-29 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 7.48,
                    "ts": "2025-08-29 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 8.21,
                    "ts": "2025-08-29 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.96,
                    "ts": "2025-08-29 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.58,
                    "ts": "2025-08-29 21:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1108,
                    "value": 6.43,
                    "ts": "2025-08-29 23:00:00",
                    "injection": false
                }
            ],
            []
        ],
        [
            [],
            []
        ]
    ],
    [
        [
            [],
            [
                {
                    "jaulaId": 1109,
                    "value": 7.98,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.94,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.97,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.99,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.9,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.83,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.74,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.67,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.44,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.88,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 8.06,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.99,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.86,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 7.81,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                }
            ]
        ],
        [
            [],
            [
                {
                    "jaulaId": 1109,
                    "value": 182.17,
                    "ts": "2025-08-28 00:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 200.06,
                    "ts": "2025-08-28 01:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 197.52,
                    "ts": "2025-08-28 02:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 208.36,
                    "ts": "2025-08-28 03:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 210.37,
                    "ts": "2025-08-28 04:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 204.56,
                    "ts": "2025-08-28 05:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 210.23,
                    "ts": "2025-08-28 06:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 190.5,
                    "ts": "2025-08-28 07:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 163.76,
                    "ts": "2025-08-28 08:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 170.06,
                    "ts": "2025-08-28 09:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 196.39,
                    "ts": "2025-08-28 10:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 204.43,
                    "ts": "2025-08-28 11:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 193.54,
                    "ts": "2025-08-28 12:00:00",
                    "injection": false
                },
                {
                    "jaulaId": 1109,
                    "value": 190.85,
                    "ts": "2025-08-28 13:00:00",
                    "injection": false
                }
            ]
        ]
    ],
    [
        [
            [],
            []
        ],
        [
            [],
            []
        ]
    ]
]
 */
    agregarTsAcumuladoJaulasConMediciones(lecturas) {
      // crear un array que contenga un resumen por Fecha-hora
      let dataFaenaDiario = []
       
      lecturas.forEach((medicion ) => {
        console.log('medicion ',medicion)
        
        
     

          let n = Math.floor(medicion.value * 100) / 100; // truncar sin rendondear
          const fec = medicion.ts;
          // const uni = medicion.jaulaId;
          const injection = medicion.injection;
          let dateSplit = ''


          if (this.granularity == 'DAY') {
            dateSplit = fec.split(" ")[0];

          } else {
            //console.log('granularidad hora', fec);
            dateSplit = fec;
          }


          dateSplit = fec;

          if (dateSplit) {



            let index = dataFaenaDiario.findIndex(function (obj) {

              return obj.ts == dateSplit;
            });



            if (index !== -1) {

              ////console.log('chk uni:', uni);
              ////console.log('chk (existe fecha ', dateSplit, ' en [])')

              let cantidad_unidades = dataFaenaDiario[index].jaulas_con_mediciones_ese_dia;
              cantidad_unidades++;

              let acumulado = parseFloat(dataFaenaDiario[index].acumulado);
              let totdia = parseFloat(n)

              if (injection) {
                dataFaenaDiario[index].injection = injection;
              } else {
                if (dataFaenaDiario[index].injection == '') {
                  dataFaenaDiario[index].injection = injection;
                }
              }


              ////console.log(uni, ': chk (valores acumulado en fecha', dateSplit, ':', acumulado)
              ////console.log(uni, ': chk (agrega en fecha', dateSplit, '):', totdia)




              dataFaenaDiario[index].acumulado = acumulado + totdia;
              dataFaenaDiario[index].jaulas_con_mediciones_ese_dia = cantidad_unidades;


            } else {


              dataFaenaDiario.push({
                'ts': dateSplit,
                'acumulado': n,
                'injection': injection,
                'value': 0,
                'jaulas_con_mediciones_ese_dia': 1
              })

            }



          }


        });

 
      return dataFaenaDiario;
    },
    parseCustomDate(str) {
      const [day, time, month, year] = str.split(' ');
      const months = {
        Jan: '01', Feb: '02', Mar: '03', Apr: '04',
        May: '05', Jun: '06', Jul: '07', Aug: '08',
        Sep: '09', Oct: '10', Nov: '11', Dec: '12'
      };
      const isoString = `${year}-${months[month]}-${day}T${time}`;
      return new Date(isoString);  //  2025-06-04T17:00:00.000Z
    },


    processSensorData(sensors, parametroId, jaulaId, faenaNombre, tipoFaena) {
      const resultados = [];
      for (const sensor of sensors) {
        for (const param of sensor.params) {
          if (param.id !== parametroId) continue;

          if (param.injectionType === 'dummy') {
            const target = tipoFaena === 'S' ? this.glosaDataTypeNatural : this.glosaSimuladaOxigenado;
            if (!target.faenas.includes(faenaNombre)) {
              target.faenas.push(faenaNombre);
            }
          }

          for (const valor of param.values) {
            if (!valor.value) continue;
            resultados.push({
              jaulaId,
              value: valor.value,
              ts: valor.ts,
              injection: valor.injection || false
            });
          }
        }
      }
      return resultados;
    },

    aggregateReadings(readings, granularity) {
      const agregados = [];

      for (const m of readings) {
        const key = granularity === 'DAY' ? m.ts.split(" ")[0] : m.ts;
        const idx = agregados.findIndex(d => d.ts === key);

        if (idx >= 0) {
          const obj = agregados[idx];
          obj.acumulado += m.value;
          obj.jaulas_con_mediciones_ese_dia++;
          if (m.injection && !obj.injection) obj.injection = true;
        } else {
          agregados.push({
            ts: key,
            acumulado: m.value,
            jaulas_con_mediciones_ese_dia: 1,
            injection: m.injection || false,
            value: 0
          });
        }
      }

      for (const d of agregados) {
        d.value = Math.floor((d.acumulado / d.jaulas_con_mediciones_ese_dia) * 100) / 100;
      }

      return agregados;
    },


    async getPreferences() {
      // iterar FAENAS, si el valor de FAENAS[n].id existe  en PREFERENCIAS[n].id, agregar 
      // en FAENAS[n] el atributo order, con el valor de PREFERENCIAS[n].order

      let objFaenas = this.$store.getters.getFaenas;
      let jsonPref = this.$store.getters.getUserPreferenceItems;
      let objPreferencias = jsonPref;

      const parsedPreferencias = objPreferencias.map(pref => ({
        ...pref,
        id: parseInt(pref.id, 10)
      }));
      objFaenas.forEach(faena => {
        const pref = parsedPreferencias.find(p => p.id === faena.id);
        if (pref) {
          faena.order = pref.order;
          faena.visible = pref.visible;

        }
      });
      objFaenas.sort((a, b) => a.order - b.order);
      await this.$store.dispatch('setFaenas', objFaenas);
      await this.$store.dispatch('droppableCreate', objFaenas);
    },


    convertirFormatoFecha(fechaOriginal) {
      if (!fechaOriginal) return null;
      const [dia, mes, año] = fechaOriginal.split(" ");
      return (dia && mes && año) ? `${año}-${mes}-${dia}` : null;

    },

    convertirFormatoFechaDMA(fechaOriginal) {
      try {
        const partes = fechaOriginal.split("-");

        if (partes.length === 3) {
          const dia = partes[0];
          let paso = parseInt(partes[1])
          const mes = this.nomMes[Number(paso)];
          const año = partes[2];
          const nuevaFecha = `${año} ${mes} ${dia}`;


          return nuevaFecha;
        }
      } catch (error) {
        console.log(error);
      }
      return null;
    },


    getRnd(min, max) {
      let flot = Math.random() * (max - min + 1) + min;

      return flot.toFixed(2);
    },
    showModalHelp() {
      //console.log("show modal");
      this.showModal = true;
    },
    handleDragOVer(event) {
      //console.log("over");
      event.preventDefault();
    },
    handleDragEnter(event) {
      console.log("enter", event);
    },
    handleDrop() {
      //console.log("DROP");
      this.$store.dispatch("droppableAdd");
      this.isDragStart = false;
    },
    handleDropFaena(id) {
      //console.log("DROP en Faena", id);
      this.$store.dispatch("setPosCurrentDroppable", id);
      this.$emit("handleDropFaena");
    },
    handleVisibilidad() {
      this.$emit("handleDropFaena");
      this.getParametrosBuscadosEnSeriesDias_2(this.startDate, this.endDate);
    },
    handleDragFaena(id) {
      //console.log("tomando faena ", id);
      this.$store.dispatch("setIdCurrentDroppable", id);
      this.isDragStart = true;
    },
    handleDragOver(event) {
      event.preventDefault();
    },
    restaDias(minus) {

      let hoy = this.$store.getters.fechaHoraActual();

      let diaHoy = String(hoy.getDate).padStart(2, '0');
      let mesHoy = String(hoy.getMonth).padStart(2, '0');
      let añoHoy = String(hoy.getFullYear).padStart(2, '0');
      let fechaHoy = `${diaHoy} ${mesHoy} ${añoHoy}`;

      let fec = this.$store.getters.restarDias(diaHoy, mesHoy, añoHoy, minus);
      let dd = String(fec.getDate).padStart(2, '0');
      let mm = String(fec.getMonth).padStart(2, '0');
      let aa = String(fec.getFullYear).padStart(2, '0');
      let fechaRestada = `${dd} ${mm} ${aa}`;


      return [fechaRestada, fechaHoy]
    },


  },


};
</script>